import { ProficiencyFeedbackFormValues } from "./ProficiencyFeedbackForm.schema";

export const defaultProficiencyFeedbackValues = {
  formState: "draft",
  statementOfProficiency: "",
  requestedNvlapFollowUp: false,
  nvlapFollowUp: false,
  potentialNonConformities: "",
  validationTeam: {
    validationTeamTwoWeeks: undefined,
    validationTeamDays: "",
  },
  missTdsGroup: {
    missTds: undefined,
    missTdsEcrs: [],
  },
  misinterpretPolicyGroup: {
    misinterpretPolicy: undefined,
    misinterpretedPolicies: [],
  },
  performTestsGroup: {
    performTests: undefined,
    performTestsEcrs: [],
  },
  quality: undefined,
  discrepancies: undefined,
  evidence: undefined,
  clarification: undefined,
  missingItems: undefined,
  comments: "",
} as ProficiencyFeedbackFormValues;
